module.exports = __webpack_public_path__ + "static/img/1.8994811b.png";